import {ApiService} from '@/api';
import {AchievementType} from '@/models';
import {
  AchievementHistory,
  AchievementsHistoryFilters,
  AddAchievementForm,
  EditAchievementForm,
  GrantAchievementForm,
} from '@/models/admin-panel/achievements';
import {AchievementsCount, GeekProfileAchievement} from '@/models/geek-profile';

export const ACHIEVEMENTS_HISTORY_LIMIT = 10;

export class AchievementsApi {
  private readonly geeksBaseUrl = '/api/geeks';
  private readonly achievementsBaseUrl = '/api/achievements';

  public async fetchAllAchievementsTypes(): Promise<AchievementType[]> {
    const response = await ApiService.get(`${this.achievementsBaseUrl}`);

    return response.json();
  }

  public async fetchGeekAchievementsCount(id: string): Promise<AchievementsCount> {
    const response = await ApiService.get(`${this.geeksBaseUrl}/${id}/achievements-count`);

    return response.json();
  }

  public async fetchGeekAchievements(id: string): Promise<GeekProfileAchievement> {
    const response = await ApiService.get(`${this.geeksBaseUrl}/${id}/achievements`);

    return response.json();
  }

  public async fetchAchievementsHistory(
    filters?: AchievementsHistoryFilters,
    offset: number = 0,
    limit: number = ACHIEVEMENTS_HISTORY_LIMIT,
  ): Promise<{ data: AchievementHistory[], totalCount: number }> {
    const response = await ApiService.get(`${this.achievementsBaseUrl}/history`,
      {
        params: {
          offset,
          limit,
          ...filters,
        },
      },
    );

    const data: AchievementHistory[] = await response.json();
    const totalCount: number = parseInt(response.headers.get('x-items-count') as string, 10);
    return new Promise((resolve) => resolve({data, totalCount}));
  }

  public async addAchievement(formData: AddAchievementForm): Promise<void> {
    const response = await ApiService.post(
      `${this.achievementsBaseUrl}/types`,
      formData,
    );

    return response.json();
  }

  public async grantAchievement(geekId: string, grantData: GrantAchievementForm): Promise<void> {
    await ApiService.post(
      `${this.geeksBaseUrl}/${geekId}/achievements`,
      grantData,
    );
  }

  public async fetchAchievementTypeBasicInfo(id: string = 'self'): Promise<AchievementType> {
    const response = await ApiService.get(`${this.achievementsBaseUrl}/${id}/basic-info`);

    return response.json();
  }

  public async editAchievement(formData: EditAchievementForm): Promise<void> {
    const response = await ApiService.put(
      `${this.achievementsBaseUrl}/types/${formData.id}`,
      formData,
    );

    return response.json();
  }

  public async deleteAchievement(id: string): Promise<void> {
    await ApiService.delete(`${this.achievementsBaseUrl}/types/${id}`);
  }
}

